import { render, staticRenderFns } from "./ViewTaskBar.vue?vue&type=template&id=107a4a96&scoped=true&"
import script from "./ViewTaskBar.vue?vue&type=script&lang=js&"
export * from "./ViewTaskBar.vue?vue&type=script&lang=js&"
import style0 from "./ViewTaskBar.vue?vue&type=style&index=0&id=107a4a96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107a4a96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VDivider,VIcon,VList,VListItem,VTextarea})
